
import {thingsApi} from './things'

export const thingUnEndorseApi = thingsApi.injectEndpoints({
  endpoints: (builder) => ({
    
    thingUnEndorse: builder.mutation({
      
      query: ({payload}) => ({
        url: '/unendorseskill',
        method: 'POST',
        body: payload,
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useThingUnEndorseMutation } = thingUnEndorseApi